module.exports = __webpack_public_path__ + "img/9-logo-interno.74ebdb8e.png";